// @flow
import React from 'react';

import Diagram from '../../../components/Diagram';

import styles from './styles.module.scss';

type Props = {
  rightResults: number,
  allResults: number,
  wrongResults: number,
  setGameResults: ([]) => void,
}

const ResultStatistics = ({
  rightResults = 0,
  allResults = 0,
  wrongResults = 0,
  setGameResults,
}: Props) => {
  const right = rightResults ? `${parseFloat((100 / allResults) * rightResults).toFixed(0)}` : '0';
  const wrong = wrongResults ? `${parseFloat((100 / allResults) * wrongResults).toFixed(0)}` : '0';
  return (
    <div className={styles.containerAdaptive} role="region" aria-label="Session results">
      <Diagram className={styles.diagramAdaptive} percent={rightResults} base={allResults} />
      <div className={styles.resultsContainerAdaptive}>
        <div className={styles.angle} />
        <div className={styles.resultBlockWrapper}>
          <div className={styles.resultsWrapperAdaptive}>
            <span className={styles.name}>All</span>
            <span className={styles.amountAdaptive}>{allResults}</span>
          </div>
          <div className={styles.resultsWrapperAdaptive}>
            <span className={styles.correct}>Correct</span>
            <div className={styles.amountWrapper}>
              <span className={styles.amountAdaptive}>{rightResults}</span>
              <span className={styles.percentAdaptive}>{`(${right}%)`}</span>
            </div>
          </div>
          <div className={styles.resultsWrapperAdaptive}>
            <span className={styles.wrong}>Wrong</span>
            <div className={styles.amountWrapper}>
              <span className={styles.amountAdaptive}>{wrongResults}</span>
              <span className={styles.percentAdaptive}>{`(${wrong}%)`}</span>
            </div>
          </div>
        </div>
        <div className={styles.resultBlockAdaptive}>
          <button
            type="button"
            className={styles.reset}
            onClick={() => setGameResults([])}
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultStatistics;
